export default __webpack_public_path__ + "static/media/Mail.d898dc24.png";